import { c as _c } from "react/compiler-runtime";
import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import { Divider, PageShell } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import getRandomID from '@/idv2/utils/get-random-id/get-random-id';
import IdDocOutcomeSelect from './components/id-doc-outcome-select';
import OverallOutcomeSelect from './components/overall-outcome-select';
import TestIdInput from './components/test-id-input';
import type { SandboxOutcomeFormData } from './types';
const getSandboxOptions = (config: OnboardingSessionConfig) => {
  const options: {
    id: string;
    component: React.ReactNode;
  }[] = [];
  if (config.sandboxConfig?.collectSandboxOutcome) {
    options.push({
      id: 'overall-outcome',
      component: <OverallOutcomeSelect config={config} />
    });
  }
  if (config.sandboxConfig?.collectDocumentOutcome) {
    options.push({
      id: 'id-doc-outcome',
      component: <IdDocOutcomeSelect allowRealOutcome={config.sandboxConfig.allowRealDocumentOutcome} />
    });
  }
  if (config.sandboxConfig?.collectSandboxId) {
    options.push({
      id: 'sandbox-id',
      component: <div className="flex flex-col justify-end border-dashed border-tertiary gap-2">
          <TestIdInput />
        </div>
    });
  }
  return options;
};
type SandboxOutcomeProps = {
  config: OnboardingSessionConfig;
  sandboxId?: string;
  onSubmit: (data: SandboxOutcomeFormData) => void;
};
export const SandboxOutcome = t0 => {
  const $ = _c(54);
  const {
    config,
    sandboxId,
    onSubmit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "sandboxOutcome"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const t2 = config.sandboxConfig?.selectedFixtureResult ?? (config.sandboxConfig?.hideLegacyFixtureOutcomes ? "use_rules_outcome" : "pass");
  const t3 = config.sandboxConfig?.collectDocumentOutcome ? "pass" : undefined;
  let t4;
  if ($[1] !== config.sandboxConfig?.collectSandboxId || $[2] !== sandboxId) {
    t4 = config.sandboxConfig?.collectSandboxId ? sandboxId ?? getRandomID() : undefined;
    $[1] = config.sandboxConfig?.collectSandboxId;
    $[2] = sandboxId;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = {
      defaultValues: {
        overallOutcome: t2,
        docVerificationOutcome: "simulated",
        idDocOutcome: t3,
        testID: t4
      },
      mode: "onChange"
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const formMethods = useForm(t5);
  let t6;
  if ($[8] !== onSubmit) {
    t6 = data => {
      onSubmit({
        ...data,
        idDocOutcome: data.docVerificationOutcome === "real" ? "real" : data.idDocOutcome
      });
    };
    $[8] = onSubmit;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleSubmit = t6;
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t7;
  let t8;
  let t9;
  if ($[10] !== config || $[11] !== formMethods || $[12] !== handleSubmit || $[13] !== t) {
    const optionsToDisplay = getSandboxOptions(config);
    T1 = FormProvider;
    t14 = formMethods;
    if ($[24] !== formMethods || $[25] !== handleSubmit) {
      t13 = formMethods.handleSubmit(handleSubmit);
      $[24] = formMethods;
      $[25] = handleSubmit;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    T0 = PageShell;
    if ($[27] !== t) {
      t10 = t(_temp);
      $[27] = t;
      $[28] = t10;
    } else {
      t10 = $[28];
    }
    if ($[29] !== t) {
      t11 = t(_temp2);
      $[29] = t;
      $[30] = t11;
    } else {
      t11 = $[30];
    }
    let t15;
    if ($[31] !== t) {
      t15 = t(_temp3);
      $[31] = t;
      $[32] = t15;
    } else {
      t15 = $[32];
    }
    if ($[33] !== t15) {
      t12 = {
        text: t15,
        type: "submit"
      };
      $[33] = t15;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    t9 = "p-4 border border-solid rounded border-tertiary";
    t7 = "flex gap-4 flex-col";
    t8 = optionsToDisplay.map((item, index) => <div key={item.id} className="flex flex-col gap-4">{item.component}{index !== optionsToDisplay.length - 1 && <Divider />}</div>);
    $[10] = config;
    $[11] = formMethods;
    $[12] = handleSubmit;
    $[13] = t;
    $[14] = T0;
    $[15] = T1;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
    $[20] = t14;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    T0 = $[14];
    T1 = $[15];
    t10 = $[16];
    t11 = $[17];
    t12 = $[18];
    t13 = $[19];
    t14 = $[20];
    t7 = $[21];
    t8 = $[22];
    t9 = $[23];
  }
  let t15;
  if ($[35] !== t7 || $[36] !== t8) {
    t15 = <div className={t7}>{t8}</div>;
    $[35] = t7;
    $[36] = t8;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t15 || $[39] !== t9) {
    t16 = <div className={t9}>{t15}</div>;
    $[38] = t15;
    $[39] = t9;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== T0 || $[42] !== t10 || $[43] !== t11 || $[44] !== t12 || $[45] !== t16) {
    t17 = <T0 title={t10} subtitle={t11} cta={t12}>{t16}</T0>;
    $[41] = T0;
    $[42] = t10;
    $[43] = t11;
    $[44] = t12;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== t13 || $[48] !== t17) {
    t18 = <form onSubmit={t13}>{t17}</form>;
    $[47] = t13;
    $[48] = t17;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== T1 || $[51] !== t14 || $[52] !== t18) {
    t19 = <T1 {...t14}>{t18}</T1>;
    $[50] = T1;
    $[51] = t14;
    $[52] = t18;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  return t19;
};
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.subtitle;
}
function _temp3($_1) {
  return $_1.cta;
}